const APP_LANGUAGE_TO_INTL_LOCALE: Record<string, string> = {
  en: 'en-US',
  es: 'es-ES',
  br: 'pt-BR',
  fr: 'fr-FR',
  zh: 'zh-CN',
  ru: 'ru-RU',
  hi: 'hi-IN',
  ar: 'ar-SA',
};

const APP_LANGUAGE_TO_MOMENT_LOCALE: Record<string, string> = {
  en: 'en',
  es: 'es',
  br: 'pt-br',
  fr: 'fr',
  zh: 'zh-cn',
  ru: 'ru',
  hi: 'hi',
  ar: 'ar',
};

export function getAppLanguage(rawLanguage?: string | null): string {
  const locale = (rawLanguage || 'en').toLowerCase();

  if (locale === 'es' || locale.startsWith('es-')) return 'es';
  if (locale === 'br' || locale === 'pt' || locale.startsWith('pt-')) return 'br';
  if (locale === 'fr' || locale.startsWith('fr-')) return 'fr';
  if (locale === 'zh' || locale.startsWith('zh-')) return 'zh';
  if (locale === 'ru' || locale.startsWith('ru-')) return 'ru';
  if (locale === 'hi' || locale.startsWith('hi-')) return 'hi';
  if (locale === 'ar' || locale.startsWith('ar-')) return 'ar';

  return 'en';
}

export function getIntlLocale(rawLanguage?: string | null): string {
  return APP_LANGUAGE_TO_INTL_LOCALE[getAppLanguage(rawLanguage)] ?? 'en-US';
}

export function getMomentLocale(rawLanguage?: string | null): string {
  return APP_LANGUAGE_TO_MOMENT_LOCALE[getAppLanguage(rawLanguage)] ?? 'en';
}
